import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { OptionsService } from 'src/app/service/options.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-body',
  templateUrl: './body.component.html',
  styleUrls: ['./body.component.less']
})



export class BodyComponent implements OnInit {


  @ViewChild('mmcBody') mmcBody: ElementRef;
  subscription:Subscription

  activeAction:string=null;
  constructor(
    private optionsService:OptionsService
  ) {
  }

  ngOnInit() {
    this.subscription = this.optionsService.options$.subscribe(data => {
      this.activeAction=this.optionsService.getActive().staticName;
    });
  }


}
